import { memo } from 'react';
import GenericIcon from './GenericIcon';

export default memo((params) => (
  <GenericIcon {...params}>
    <path d="M5.99527 11.9953L10.0256 11.9745" />
    <path d="M20.9096 11.9548L3.58553 20.0865C3.48681 20.1232 3.37963 20.1308 3.27674 20.1083C3.17384 20.0859 3.07956 20.0343 3.00509 19.9599C2.93062 19.8854 2.87909 19.7911 2.85664 19.6882C2.83419 19.5853 2.84175 19.4782 2.87842 19.3794L5.3533 11.9548L2.87842 4.53019C2.84175 4.43147 2.83419 4.32429 2.85664 4.2214C2.87909 4.1185 2.93062 4.02422 3.00509 3.94975C3.07956 3.87528 3.17384 3.82375 3.27673 3.8013C3.37963 3.77885 3.48681 3.78641 3.58553 3.82308L20.9096 11.9548Z" />
  </GenericIcon>
));
